<template>
  <top-nav :pageList="pageList">
    <slot></slot>
  </top-nav>
</template>

<script>
import topNav from "@/components/topNav";
export default {
  components: {
    topNav
  },
  data() {
    return {
      pageList: []
    };
  },
  created() {
    for (let i in this.$store.state.settingList) {
      if (this.$store.state.settingList[i].name === "系统管理") {
        this.pageList = this.$store.state.settingList[i].children;
      }
    }
  }
};
</script>
